
import { defineComponent } from 'vue';
import vSelect from 'vue-select';

import pokemonsMove from '@/components/pokemonMoves.vue';
import { NO_IMAGE_URL } from './constants';
import { useData } from '@/composables/useData';
import { useSearchedPokemonsByMoves } from '@/composables/useSearchedPokemonsByMoves';

export default defineComponent({
  components: {
    vSelect,
    pokemonsMove,
  },
  setup() {
    const { pokemons, moves, getTypeByName } = useData();
    const { searchMoveOne, searchMoveTwo, searchMoveThree, searchMoveFour, isSearchEmpty, searchedPokemons } =
      useSearchedPokemonsByMoves(pokemons);

    return {
      moves,
      getTypeByName,
      searchMoveOne,
      searchMoveTwo,
      searchMoveThree,
      searchMoveFour,
      isSearchEmpty,
      searchedPokemons,
      noImageUrl: NO_IMAGE_URL,
    };
  },
});
